import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { DealCompanySetting } from "~/models/CompanySetting";

const paths = {
	index: "/vendors/deal_company_settings"
};

type TIndex = (searchWord: string) => SwrReturnType<DealCompanySetting[]>;
type ReturnType = {
	index: TIndex;
};
export const useDealCompanySettings = (): ReturnType => {
	const index: TIndex = (searchWord: string) => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error, isLoading } = useSWR({
			params: { searchWord },
			url: paths.index
		});
		return {
			data: data ?? null,
			error,
			isLoading,
			mutate
		};
	};
	return { index };
};
